import taxonomyAPIFactory from "../taxonomy/api"

const api = taxonomyAPIFactory({ taxonomyId: 'muscle' })

export default api